export default function Machines_D_6 (number = 1) {
  return {
    name: '化工厂',
    icon: '/static/img/machines/d6.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_6.js